import { useQueryClient } from '@tanstack/react-query';
import keys from './keys';
import useApiMutation from '../useApiMutation';

const useSetPodcastindex = () => {
  const queryClient = useQueryClient();

  const enablePodcastIndex = useApiMutation({
    getRequestUrl: ({ showId } = {}) => `/shows/${showId}/podcastIndex`,
    method: 'POST',
    onSuccess: (newShowData) => {
      queryClient.setQueryData(keys(newShowData.showId).show, newShowData);
    },
  });

  return {
    enablePodcastIndex: enablePodcastIndex.mutate,
    isEnablePodcastIndexLoading: enablePodcastIndex.isLoading,
    isEnablePodcastIndexError: enablePodcastIndex.isError,
    isEnablePodcastIndexSuccess: enablePodcastIndex.isSuccess,
    ...enablePodcastIndex,
  };
};

export default useSetPodcastindex;
